import styled from 'styled-components'
import { Top } from '../styles'
import { BoxDefault } from '../../../components/BoxContainer/styles'

export const BoxButtonsHead = styled.div`
  display: flex;
  gap: 24px;
`

export const Content = styled.div`
  ${Top} {
    margin-bottom: 40px;
    h2 {
      font-weight: bold;
      font-size: var(--font-size-md);
      color: var(--text-tertiary);
    }
  }

  .spaceTop {
    margin-top: 40px;
  }
`

export const WrapDashs = styled(BoxDefault)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;

  > div {
    flex: 1;
  }
`

export const WrapGraphics = styled(BoxDefault)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;

  ${BoxDefault} {
    flex: 1;

    h4 {
      font-size: var(--font-size-sm);
      color: var(--text-tertiary);
      font-weight: bold;
      margin-top: 31px;
    }
  }
`
